import { useEffect, useState } from "react";
import {
  IconX,
  IconSend,
  IconUser,
  IconBriefcase,
  IconPlugConnectedX,
  IconMessage2,
  IconNotes,
} from "@tabler/icons-react";
import { errorHandler } from "../../../utils";
import { cancelMatchTalent } from "../../../services/clientCalls";
import styles from "./cancelMatchModal.module.css";
import Button from "../../UI/Button/button";
import Input, { Textarea } from "../../UI/FormInput/input";

const CancelMatchModal = ({
  setShowModal,
  jobId,
  setSuccessModal,
  setMatchCancelled,
  fetchJobApplicants,
  setMatchTimeInfo,
  setIsCancelMatchBtn,
}) => {
  const [load, setLoad] = useState(false);
  const [forms, setForms] = useState({
    feedbackReason: "requirements_changed",
    feedbackText: "",
    reasonForCancelling: "",
  });
  const twentyFourHours = 24 * 60 * 60 * 1000;
  const expiryTime = Date.now() + twentyFourHours;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoad(true);
    try {
      const res = await cancelMatchTalent(jobId, forms);
      if (res.data?.success) {
        setSuccessModal(true);
        setShowModal(false);
        setMatchCancelled(true);
        fetchJobApplicants();
        setMatchTimeInfo(null);
        setIsCancelMatchBtn(false);
        setForms({
          jobId: "",
          feedback: "",
          reasonForCancelling: "",
        });
      }
      setLoad(false);
    } catch (error) {
      setLoad(false);
      error.response?.data
        ? errorHandler(error.response.data.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    }
  };

  return (
    <div
      className={styles.modalBackdrop}
      onClick={(e) => {
        if (e.target === e.currentTarget) setShowModal(false);
      }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="cmTitle"
    >
      <div className={styles.modalCard}>
        <button
          className={styles.modalClose}
          aria-label="Close"
          onClick={() => setShowModal(false)}
          type="button"
        >
          <IconX size={17} />
        </button>

        {/* Animated hero — connection releasing motif */}
        <div className={styles.cmHero} aria-hidden="true">
          <div className={styles.cmHeroStage}>
            <div className={styles.cmNodeLeft}>
              <IconUser size={20} />
            </div>
            <div className={styles.cmLink} />
            <div className={styles.cmRing} />
            <div className={`${styles.cmRing} ${styles.cmRingSecond}`} />
            <div className={styles.cmBadge}>
              <IconPlugConnectedX size={18} />
            </div>
            <div className={styles.cmNodeRight}>
              <IconBriefcase size={20} />
            </div>
          </div>
        </div>

        <div className={styles.cmHeading}>
          <div className={styles.cmHeadingTitle} id="cmTitle">
            Before you proceed
          </div>
          <div className={styles.cmHeadingSub}>
            Please tell us why you unmatched with that talent.
          </div>
        </div>

        <div className={styles.modalBody}>
          <form id="cancelMatchForm" onSubmit={handleSubmit}>
            <div className={styles.field}>
              <Input
                label="Summary of Feedback"
                labelIcon={<IconMessage2 size={14} />}
                id="cmSummary"
                size="lg"
                placeholder="e.g. Role requirements changed"
                maxLength={120}
                value={forms.feedbackText}
                onChange={(e) => {
                  setForms((prevState) => ({
                    ...prevState,
                    feedbackText: e.target.value,
                  }));
                }}
              />
            </div>

            <div className={styles.field}>
              <Textarea
                label="Tell Us about it"
                labelIcon={<IconNotes size={14} />}
                id="cmDetails"
                rows={5}
                placeholder="Share a bit more context so we can improve future matches…"
                value={forms.reasonForCancelling}
                onChange={(e) => {
                  setForms((prevState) => ({
                    ...prevState,
                    reasonForCancelling: e.target.value,
                  }));
                }}
              />
            </div>

            <p className={styles.legal}>
              Any information you provide is in accordance with our{" "}
              <a target="_blank" rel="noreferrer" href="/privacy-policy">
                Privacy Policy
              </a>{" "}
              &{" "}
              <a target="_blank" rel="noreferrer" href="/terms-of-service">
                Terms of Use
              </a>
            </p>

            <div className={styles.modalFoot}>
              <Button
                variant="ghostFilled"
                size="lg"
                onClick={() => setShowModal(false)}
              >
                Keep Match
              </Button>
              <Button
                variant="dangerSolid"
                size="lg"
                leftIcon={<IconSend size={15} />}
                loading={load}
                disabled={
                  !forms.feedbackText || !forms.reasonForCancelling || !jobId
                }
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CancelMatchModal;
